import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const uploadCertificate = (fileName, data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.CERTIFICATE_MANAGEMENT.UPLOAD_CERTIFICATE(fileName),
    data
  );
};

export default uploadCertificate;
